import React from 'react';
import { Paper, Box, Typography, Divider } from '@mui/material';

const TeacherDetailsSummary = ({ coursesData, transfers, teacher }) => {
  // Calculate total payments from courses
  const totalPayments = coursesData?.grandTotal || 0;

  // Calculate total compensation
  const totalCompensation = coursesData?.courses?.reduce((sum, courseStat) => {
    const salaryPerLesson = teacher?.salaryPerLesson || 0;
    return sum + (salaryPerLesson * courseStat.lessonsWithAttendance);
  }, 0) || 0;

  // Calculate total transfers (transfer da docente - transfer verso docente)
  const totalTransfers = transfers.reduce((sum, transfer) => {
    if (transfer.direction === 'from') {
      return sum + transfer.amount; // dal docente (positivo per l'azienda)
    } else {
      return sum - transfer.amount; // verso docente (negativo per l'azienda)
    }
  }, 0);

  // Final balance = Totale pagamenti registrati - totale compensi +/- totale trasferimenti
  const finalBalance = totalPayments - totalCompensation - totalTransfers;

  return (
    <Paper sx={{ p: 3 }}>
      <Typography variant="h6" sx={{ mb: 2 }}>
        Riepilogo
      </Typography>
      <Divider sx={{ mb: 2 }} />
      
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="body1" color="text.secondary">
            Totale Pagamenti Registrati Dal Docente:
          </Typography>
          <Typography variant="h6" fontWeight="bold" color="success.main">
            €{totalPayments.toFixed(2)}
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="body1" color="text.secondary">
            Totale Rimborsi Verso Docente:
          </Typography>
          <Typography variant="h6" fontWeight="bold" color="error.main">
            -€{totalCompensation.toFixed(2)}
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="body1" color="text.secondary">
            Totale Trasferimenti:
          </Typography>
          <Typography 
            variant="h6" 
            fontWeight="bold"
            color={totalTransfers < 0 ? 'success.main' : 'error.main'}
          >
           {totalTransfers >= 0 ? '-' : ''}€{Math.abs(totalTransfers).toFixed(2)}
          </Typography>
        </Box>

        <Divider sx={{ my: 1 }} />

        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="h6" fontWeight="bold">
            Saldo Finale:
          </Typography>
          <Typography 
            variant="h5" 
            fontWeight="bold"
            color={finalBalance >= 0 ? 'success.main' : 'error.main'}
          >
            €{finalBalance.toFixed(2)}
          </Typography>
        </Box>
      </Box>
    </Paper>
  );
};

export default TeacherDetailsSummary;
